// Lazy card loading (F04): one small JSON per card, cached.
export interface Card {
  id: string;
  kind: 'full' | 'stub';
  title: string;
  name: string;
  latin: string | null;
  oneLiner: string;
  html: { what_it_does?: string; surprising_fact?: string; why_it_matters?: string };
  text: Record<string, string>;
  links: Array<{ title: string; url: string }>;
  sources: Array<{ claim: string; cite: string; url?: string }>;
  seeAlso: string[];
  status: string;
  reviewedBy: string | null;
  updated: string;
}

const cache = new Map<string, Promise<Card | null>>();
const ready = new Map<string, Card | null>();

export function loadCard(id: string): Promise<Card | null> {
  if (!cache.has(id)) {
    cache.set(
      id,
      fetch(`/content/cards/${id}.json`)
        .then((r) => (r.ok ? (r.json() as Promise<Card>) : null))
        .catch(() => null)
        .then((c) => {
          ready.set(id, c);
          return c;
        }),
    );
  }
  return cache.get(id)!;
}

/** Synchronously returns an already-loaded card (undefined if not loaded yet) so revisits render instantly. */
export function peekCard(id: string): Card | null | undefined {
  return ready.get(id);
}
